import { Link } from "@tanstack/react-router";
import { Download } from "lucide-react";
import { initials } from "@/lib/skills/format";
import type { SkillListItem } from "@/lib/skills/types";
import { CategoryTag } from "./CategoryTag";
import { RiskBadge } from "./RiskBadge";
import { Stars } from "./Stars";

export function SkillCard({ skill }: { skill: SkillListItem }) {
  const authorInitials = initials(skill.authorName);
  return (
    <Link
      to="/skill/$id"
      params={{ id: skill.slug }}
      className="group flex flex-col gap-3 rounded-lg border border-border-1 bg-white p-5 shadow-xs transition-all hover:-translate-y-[3px] hover:shadow-md"
    >
      <div className="flex items-start justify-between gap-2">
        <div className="flex flex-wrap gap-1.5">
          {skill.cat.map((c) => (
            <CategoryTag key={c} category={c} />
          ))}
        </div>
        <RiskBadge level={skill.risk} />
      </div>
      <div>
        <h3 className="font-display text-base font-bold text-fg-1 group-hover:text-blue">
          {skill.title}
        </h3>
        <p className="mt-1 line-clamp-2 text-sm text-fg-2">{skill.desc}</p>
      </div>
      <div className="mt-auto flex items-center justify-between border-t border-border-1 pt-3">
        <div className="flex items-center gap-2">
          <span className="grid size-6 place-items-center rounded-full bg-[image:var(--nymbl-gradient)] text-[10px] font-bold text-white">
            {authorInitials}
          </span>
          <span className="text-xs text-fg-3">
            {skill.authorName} · v{skill.version}
          </span>
        </div>
      </div>
      <div className="flex items-center justify-between">
        <Stars value={skill.rating} count={skill.ratingCount} />
        <span className="inline-flex items-center gap-1 text-xs text-fg-3">
          <Download className="size-3.5" />
          {skill.downloads.toLocaleString()}
        </span>
      </div>
    </Link>
  );
}
